import {lazy} from '@aboutyou/lazy-imports';

export const ToastNotifications = lazy(() =>
  import('./ToastNotifications.eager').then(mod => ({
    default: mod.ToastNotifications,
  })),
);
